import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Control Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M249.761 193.319c-4.9 4.905-12.849 4.905-17.748 0L127.999 89.289 23.984 193.319c-6.831 6.83-18.496 3.705-20.996-5.627a12.55 12.55 0 0 1 3.248-12.122L119.124 62.682c4.9-4.906 12.85-4.906 17.749 0L249.76 175.57c4.905 4.9 4.905 12.849 0 17.749" }, null, -1)
  ]))]))
}
export default { render: render }